import { render, staticRenderFns } from "./Preregistro.vue?vue&type=template&id=452275d4&"
import script from "./Preregistro.vue?vue&type=script&lang=js&"
export * from "./Preregistro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports